import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "setup-assistant",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "roles-and-permissions" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
  childRoutes: [],
});
